export interface VideoItem {
  id: number;
  title: string;
  description: string;
  cover: string;
  category: string;
  duration: string;
  views: string;
  date: string;
  tags: string[];
  content: string;
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "2024年度热门电影精选合集",
    description: "汇集2024年最受欢迎的热门电影作品，从动作大片到温情剧情，一部不落，为您带来极致的观影体验。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20artwork%20with%20dramatic%20lighting%20and%20warm%20toned%20atmosphere%2C%20abstract%20film%20grain%20texture%20overlay%2C%20artistic%20composition%20with%20soft%20cherry%20blossom%20petals%20floating%2C%20elegant%20and%20modern%20design&width=800&height=450&seq=video-cover-01&orientation=landscape",
    category: "91-video",
    duration: "128分钟",
    views: "128.5万",
    date: "2024-06-15",
    tags: ["热门", "电影", "动作", "剧情"],
    content: "这是一部精彩的电影作品，讲述了一个引人入胜的故事。影片以精湛的摄影技巧和深刻的情感表达赢得了观众的广泛好评。导演运用独特的镜头语言，将角色的内心世界展现得淋漓尽致。影片中的每一个场景都经过精心设计，配乐更是为整部作品增添了无穷的感染力。",
  },
  {
    id: 2,
    title: "经典港片回顾：黄金年代",
    description: "重温香港电影的黄金时代，从武侠到警匪，从喜剧到爱情，那些年我们追过的经典港片一次看个够。",
    cover: "https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20retro%20style%20artwork%20with%20nostalgic%20neon%20light%20vibe%2C%20warm%20golden%20color%20palette%2C%20abstract%20cityscape%20silhouette%2C%20elegant%20composition%20with%20soft%20pink%20accents&width=800&height=450&seq=video-cover-02&orientation=landscape",
    category: "91-video",
    duration: "95分钟",
    views: "96.3万",
    date: "2024-05-20",
    tags: ["经典", "港片", "怀旧"],
    content: "香港电影在华语电影史上占据着不可替代的地位。黄金年代的港片以其独特的叙事风格、出色的动作设计和鲜明的人物塑造征服了无数观众。本片汇集了那个时代最具代表性的作品，带您重返那个充满创意与激情的年代。",
  },
  {
    id: 3,
    title: "高分纪录片：自然的力量",
    description: "探索地球上最壮观的自然景观，从极地冰原到热带雨林，体验大自然令人震撼的力量与美丽。",
    cover: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20style%20artwork%20with%20majestic%20mountain%20landscape%20and%20aurora%20borealis%2C%20warm%20earthy%20tones%2C%20cinematic%20wide%20angle%20composition%2C%20atmospheric%20and%20breathtaking%20visual&width=800&height=450&seq=video-cover-03&orientation=landscape",
    category: "97-video",
    duration: "150分钟",
    views: "75.8万",
    date: "2024-04-10",
    tags: ["纪录片", "自然", "高分"],
    content: "这部纪录片历时五年拍摄完成，摄制组足迹遍布七大洲。从北极的极光到南极的企鹅群，从非洲大草原的动物迁徙到亚马逊雨林的生态系统，影片以4K超高清画质记录下了地球上最令人叹为观止的自然奇观。",
  },
  {
    id: 4,
    title: "热血动漫：少年冒险之旅",
    description: "跟随少年主角踏上一段惊心动魄的冒险之旅，友情、勇气与梦想交织的动漫佳作。",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20artwork%20with%20vibrant%20energy%20and%20dynamic%20action%20poses%2C%20warm%20sunset%20color%20gradient%20background%2C%20youthful%20adventure%20theme%2C%20artistic%20composition%20with%20cherry%20blossom%20elements&width=800&height=450&seq=video-cover-04&orientation=landscape",
    category: "97-video",
    duration: "24分钟×12集",
    views: "210.2万",
    date: "2024-03-05",
    tags: ["动漫", "热血", "冒险", "少年"],
    content: "这部动漫讲述了普通少年在一次偶然的机会中获得了神秘力量，从此踏上了一条充满挑战的冒险之路。在旅途中，他结识了志同道合的伙伴，共同对抗邪恶势力，守护世界的和平。精美的画面制作和扣人心弦的剧情让本作成为当季最热门的动漫之一。",
  },
  {
    id: 5,
    title: "都市爱情：遇见你真好",
    description: "现代都市中的浪漫爱情故事，两个看似平行的灵魂在命运的安排下相遇，演绎一段温暖人心的爱恋。",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20style%20artwork%20with%20soft%20warm%20lighting%2C%20city%20skyline%20at%20sunset%2C%20couple%20silhouette%2C%20gentle%20pink%20and%20golden%20color%20palette%2C%20elegant%20and%20dreamy%20atmosphere&width=800&height=450&seq=video-cover-05&orientation=landscape",
    category: "51-video",
    duration: "110分钟",
    views: "89.6万",
    date: "2024-02-14",
    tags: ["爱情", "都市", "浪漫", "温情"],
    content: "在繁华的都市中，两个原本毫无交集的人因为一次偶然的邂逅而走到了一起。从陌生到熟悉，从误会到理解，他们用真心换来了最美的爱情。影片以细腻的笔触描绘了现代都市人的情感世界，温情而不失深度。",
  },
  {
    id: 6,
    title: "悬疑推理：暗夜追踪",
    description: "紧张刺激的悬疑推理剧，跟随侦探的视角揭开层层迷雾，寻找隐藏在暗处的真相。",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20style%20artwork%20with%20dark%20alleyway%20and%20dramatic%20shadows%2C%20warm%20amber%20street%20light%2C%20noir%20atmosphere%2C%20elegant%20composition%20with%20suspenseful%20mood&width=800&height=450&seq=video-cover-06&orientation=landscape",
    category: "51-video",
    duration: "135分钟",
    views: "156.4万",
    date: "2024-01-28",
    tags: ["悬疑", "推理", "犯罪", "烧脑"],
    content: "一宗看似普通的失踪案背后隐藏着惊天秘密。经验丰富的侦探接手此案后，发现案件远比想象中复杂。随着调查的深入，一个庞大的犯罪网络逐渐浮出水面。影片节奏紧凑，剧情反转不断，让观众始终保持高度紧张。",
  },
  {
    id: 7,
    title: "爆笑喜剧：欢乐一家人",
    description: "全家欢笑的喜剧佳作，温暖幽默的家庭故事，让您在笑声中感受亲情的珍贵。",
    cover: "https://readdy.ai/api/search-image?query=Family%20comedy%20style%20artwork%20with%20bright%20and%20cheerful%20atmosphere%2C%20warm%20home%20interior%20setting%2C%20joyful%20and%20colorful%20composition%2C%20playful%20and%20lighthearted%20design&width=800&height=450&seq=video-cover-07&orientation=landscape",
    category: "91-video",
    duration: "102分钟",
    views: "67.9万",
    date: "2024-01-10",
    tags: ["喜剧", "家庭", "欢乐", "温情"],
    content: "这是一个普通却又充满欢乐的家庭故事。三代同堂的大家庭里，每天都上演着令人捧腹的趣事。从爷爷的固执到孙子的调皮，从夫妻之间的磨合到婆媳之间的相处，影片以轻松幽默的方式展现了当代中国家庭的真实面貌。",
  },
  {
    id: 8,
    title: "科幻巨制：星际穿越者",
    description: "震撼的视觉特效搭配深刻的哲学思考，一部关于人类探索宇宙奥秘的科幻史诗。",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20artwork%20with%20spaceship%20and%20distant%20galaxy%2C%20warm%20nebula%20colors%2C%20epic%20scale%20composition%2C%20cinematic%20and%20visionary%20design%20with%20subtle%20pink%20highlights&width=800&height=450&seq=video-cover-08&orientation=landscape",
    category: "97-video",
    duration: "168分钟",
    views: "189.7万",
    date: "2023-12-20",
    tags: ["科幻", "宇宙", "探险", "特效"],
    content: "在不远的未来，人类面临着地球资源枯竭的危机。一支由顶尖科学家和宇航员组成的团队踏上了寻找新家园的星际之旅。影片以惊人的视觉特效和深刻的科学理念，展现了人类面对未知时的勇气与智慧。",
  },
  {
    id: 9,
    title: "武侠传奇：江湖风云录",
    description: "刀光剑影的江湖世界，侠客们的恩怨情仇，一部荡气回肠的武侠巨制。",
    cover: "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20style%20artwork%20with%20ancient%20Chinese%20landscape%2C%20misty%20mountains%20and%20bamboo%20forest%2C%20warm%20ink%20wash%20painting%20aesthetic%2C%20elegant%20and%20heroic%20composition&width=800&height=450&seq=video-cover-09&orientation=landscape",
    category: "91-video",
    duration: "145分钟",
    views: "234.1万",
    date: "2023-11-15",
    tags: ["武侠", "江湖", "动作", "古装"],
    content: "江湖，一个充满传奇的地方。年轻的侠客背负着家族的使命踏入江湖，在经历了无数生死考验之后，逐渐成长为一代大侠。影片融合了传统武侠精神和现代电影技术，打斗场面精彩绝伦，人物塑造饱满立体。",
  },
  {
    id: 10,
    title: "美食纪录片：舌尖上的风味",
    description: "探寻中国各地的特色美食，从街头小吃到精致料理，用镜头记录下食物背后的文化与情感。",
    cover: "https://readdy.ai/api/search-image?query=Food%20documentary%20style%20artwork%20with%20elegant%20Chinese%20cuisine%20presentation%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20dishes%20on%20wooden%20table%2C%20rich%20and%20appetizing%20composition%20with%20soft%20natural%20light&width=800&height=450&seq=video-cover-10&orientation=landscape",
    category: "97-video",
    duration: "45分钟×8集",
    views: "312.5万",
    date: "2023-10-08",
    tags: ["美食", "纪录片", "文化", "中国"],
    content: "美食不仅仅是味觉的享受，更是一种文化的传承。本片深入中国各地，探访那些隐藏在街头巷尾的美食传奇。从四川的麻辣火锅到广东的早茶点心，从东北的铁锅炖到江南的精致小炒，每一道菜背后都有一个动人的故事。",
  },
  {
    id: 11,
    title: "音乐纪录片：华语金曲三十年",
    description: "回顾华语乐坛三十年来的经典金曲，聆听那些陪伴几代人成长的旋律与故事。",
    cover: "https://readdy.ai/api/search-image?query=Music%20documentary%20style%20artwork%20with%20vintage%20vinyl%20records%20and%20microphone%2C%20warm%20nostalgic%20lighting%2C%20golden%20age%20music%20atmosphere%2C%20elegant%20retro%20composition&width=800&height=450&seq=video-cover-11&orientation=landscape",
    category: "51-video",
    duration: "60分钟×6集",
    views: "198.3万",
    date: "2023-09-25",
    tags: ["音乐", "华语", "经典", "怀旧"],
    content: "三十年，足以让一个时代更迭。华语乐坛在这三十年间诞生了无数经典之作，从邓丽君的柔情似水到周杰伦的新潮创新，每一首歌都是一个时代的印记。本片邀请众多音乐人讲述那些金曲背后的创作故事。",
  },
  {
    id: 12,
    title: "体育纪实：冠军之路",
    description: "跟随中国运动员的脚步，记录他们从默默无闻到站上世界之巅的奋斗历程。",
    cover: "https://readdy.ai/api/search-image?query=Sports%20documentary%20style%20artwork%20with%20athletic%20silhouette%20at%20stadium%20sunset%2C%20dramatic%20lighting%2C%20inspirational%20and%20powerful%20composition%2C%20warm%20golden%20hour%20atmosphere&width=800&height=450&seq=video-cover-12&orientation=landscape",
    category: "51-video",
    duration: "55分钟×10集",
    views: "145.6万",
    date: "2023-08-18",
    tags: ["体育", "纪录片", "励志", "竞技"],
    content: "每一位冠军的背后都有不为人知的艰辛。本片深入国家训练基地，记录了多位中国顶尖运动员的日常训练和生活。从清晨五点的晨跑到深夜的加练，他们用汗水和毅力诠释了什么是真正的体育精神。",
  },
];